import { render, staticRenderFns } from "./adBook.vue?vue&type=template&id=6ede27c2&"
import script from "./adBook.vue?vue&type=script&lang=js&"
export * from "./adBook.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports